import { API_BASE, fetchJson } from './client';

export const potree = {
  getMetadata: (cacheHash: string) => fetchJson<any>(`/potree/metadata/${cacheHash}`),
  getServerUrl: (_type: string, identifier: string) =>
    `${API_BASE}/potree/pointclouds/${identifier}/metadata.json`,
  getViewerUrl: (cacheHash: string) =>
    `${API_BASE}/potree/viewer/examples/coreskan-viewer.html?pointcloud=${encodeURIComponent(`/api/potree/pointclouds/${cacheHash}/metadata.json`)}`,
  getCopcViewerUrl: (copcUrl: string) =>
    `${API_BASE}/potree/viewer/examples/coreskan-viewer.html?pointcloud=${encodeURIComponent(copcUrl)}`,
  detectCache: (projectId: string) =>
    fetchJson<{ found: boolean; cacheEntries?: Array<{ cacheHash: string; name?: string; points?: number }>; registered?: number; removed?: number }>(
      `/potree/detect/${projectId}`, { method: 'POST' }
    ),
};
